import { render, staticRenderFns } from "./Selo.vue?vue&type=template&id=1a074736&scoped=true"
import script from "./Selo.vue?vue&type=script&lang=js"
export * from "./Selo.vue?vue&type=script&lang=js"
import style0 from "./Selo.vue?vue&type=style&index=0&id=1a074736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a074736",
  null
  
)

export default component.exports